import { ModalDialog } from 'components/ModalDialog';
import { Loader } from 'uikit';

interface IModalLoadingProps {
    title: string;
    onClose: () => void;
}

export const ModalLoading = ({ title, onClose }: IModalLoadingProps) => (
    <ModalDialog title={title} isOpen hasOverlay withTitleCloseButton isOnClickOutsideDisable onClose={onClose}>
        <Loader style={{ height: '180px', position: 'static', transform: 'none' }} />
    </ModalDialog>
);

ModalLoading.displayName = 'ModalLoading';
